import React from 'react';
import EmployerHeader from './EmployerHeader';
import EmployerTopNav, { type EmployerNavKey } from './EmployerTopNav';

type EmployerPageShellProps = {
  activeSection?: EmployerNavKey;
  children: React.ReactNode;
  navChildren?: React.ReactNode;
};

const EmployerPageShell: React.FC<EmployerPageShellProps> = ({
  activeSection,
  children,
  navChildren,
}) => {
  return (
    <div className="min-h-screen bg-[#f8faf9] font-body text-[#0f172a]">
      <EmployerHeader />

      <main className="mx-auto w-full max-w-[1180px] px-6 py-8 space-y-6">
        <EmployerTopNav activeSection={activeSection}>{navChildren}</EmployerTopNav>
        {children}
      </main>
    </div>
  );
};

export default EmployerPageShell;
